<template>
    <div class="@container">
        <BackLink
            v-if="previousRoute?.name === 'HotelProperty' && property.id"
        />
        <div>
            <div
                class="grid grid-cols-12 gap-4 pl-0 justify-between relative mt-4 mb-5 lg:mb-10"
            >
                <div class="col-span-12 grid grid-cols-12 gap-4">
                    <!-- Left: Title -->

                    <div class="md:mb-4 sm:mb-0 col-span-12 md:col-span-8">
                        <h1
                            class="text-2xl md:text-3xl text-gray-800 dark:text-slate-100 font-bold mb-3"
                        >
                            Availability Alerts
                        </h1>
                        <p>
                            Keep track of your upcoming dream hotel stays.
                            Easily manage and view all your award availability
                            alerts in one convenient place.
                        </p>
                    </div>

                    <div
                        class="col-span-12 md:col-span-4 items-center justify-end hidden @md:flex"
                    >
                        <CreateAlertButton :item="selectedProperty" />
                        <!-- <a
                        href="#"
                        aria-haspopup="true"
                        aria-expanded="false"
                        role="button"
                        class="btn !w-auto bg-white dark:bg-slate-800 border-gray-200 hover:border-gray-300 text-gray-500 hover:text-gray-600 !ml-6"
                    >
                        <span class="sr-only">Filter</span>
                        <wbr data-v-6585dfb5="" />
                        <svg class="w-4 h-4 fill-current" viewBox="0 0 16 16">
                            <path
                                d="M9 15H7a1 1 0 010-2h2a1 1 0 010 2zM11 11H5a1 1 0 010-2h6a1 1 0 010 2zM13 7H3a1 1 0 010-2h10a1 1 0 010 2zM15 3H1a1 1 0 010-2h14a1 1 0 010 2z"
                            ></path>
                        </svg>
                    </a> -->
                    </div>
                </div>
            </div>
            <div
                class="w-full sm:pt-8 flex justify-between items-center flex-col"
            >
                <div
                    class="flex w-full items-center gap-4 flex-col sm:flex-row"
                >
                    <h2
                        class="sm:hidden font-medium text-xs w-full flex justify-start -mb-3"
                    >
                        Filter Alerts by:
                    </h2>
                    <FilterGroupDropdown
                        btnLabel="Hotel Brand"
                        :options="groupsFilters"
                        labelKey="name"
                        origin="alerts"
                        :showOptionImages="true"
                        :selected="selectedGroups"
                        valueKey="slug"
                        :disableOnSelectProperty="true"
                        :isDisabled="loading"
                        @clearSelected="clearSelectedGroups"
                        @selectionMade="handleSelectGroup"
                    />
                    <FilterGroupDropdown
                        btnLabel="Alert Status"
                        :disableOnSelectProperty="false"
                        :options="statusOptions"
                        origin="alerts"
                        :selected="selectedStatuses"
                        valueKey="name"
                        :isDisabled="loading"
                        @clearSelected="clearSelectedStatuses"
                        @selectionMade="(v) => handleSelectStatus(v)"
                    />
                    <SearchByName :preloadData="true" dropdownType="select" />
                </div>
                <div class="flex justify-between w-full pt-6">
                    <p class="text-slate-600 dark:text-slate-400">
                        {{ filteredAlerts.length }} alert{{
                            filteredAlerts.length > 1 ||
                            filteredAlerts.length === 0
                                ? 's'
                                : ''
                        }}
                    </p>

                    <InputSelect
                        :isDisabled="loading"
                        :options="sortOptions"
                        :previouslySelected="activeSort"
                        @sort="(input) => sortAlerts(input)"
                    />
                </div>
            </div>
            <AlertsTable />
        </div>
    </div>
</template>

<script>
import { mapState, mapActions } from 'pinia';
import { useAlertsStore } from '@/store/alerts';
import { useHotelsStore } from '@/store/hotels';
import { useAppStore } from '@/store/app';
import CreateAlertButton from '@/components/alerts/create-alert-button.vue';
import FilterGroupDropdown from '@/components/ui/filter-group-dropdown/filter-group-dropdown.vue';
import InputSelect from '@/components/ui/inputs/input-select.vue';
import AlertsTable from '@/components/alerts/alerts-table/alerts-table.vue';
import SearchByName from '@/components/hotels/search/search-by-name/search-by-name.vue';
import BackLink from '@/components/ui/back-link/ui-back-link.vue';

export default {
    components: {
        AlertsTable,
        BackLink,
        CreateAlertButton,
        FilterGroupDropdown,
        InputSelect,
        SearchByName,
    },
    data: () => ({
        activeSort: 'check_in',
        errors: [],
        sortDirection: 'asc',
        sortOptions: [
            { name: 'Default Sort', value: null },
            {
                name: 'Newest found',
                value: 'found',
            },
            {
                name: 'Created (newest first)',
                value: 'created_at',
            },
            {
                name: 'Created (oldest first)',
                value: '-created_at',
            },
        ],
    }),

    computed: {
        ...mapState(useAppStore, ['previousRoute']),
        ...mapState(useAlertsStore, [
            'selectedGroups',
            'selectedStatuses',
            'groupsFilters',
            'loading',
            'filteredAlerts',
            'alertsViewFilters',
            'activeProperty',
            'selectedProperty',
            'statusOptions',
        ]),
        ...mapState(useHotelsStore, ['autoSuggestQuery', 'property']),
    },

    methods: {
        ...mapActions(useAlertsStore, [
            'setActiveProperty',
            'getAlerts',
            'setSelectedGroups',
            'setSelectedStatuses',
            'setAlertsViewFilters',
            'clearSelectedStatuses',
            'clearSelectedGroups',
            'replaceSelectedProperties',
            'setSelectedProperties',
            'setLoading',
        ]),
        sortAlerts(val) {
            if (!val) {
                val = 'check_in';
            }
            if (val.startsWith('-')) {
                this.sortDirection = 'desc';
                this.activeSort = val.slice(1);
            } else {
                this.sortDirection = 'asc';
                this.activeSort = val;
            }

            this.getAlerts({
                column: this.activeSort,
                direction: this.sortDirection,
                // status: 'active',
            });
        },
        handleSelectGroup(group) {
            this.setLoading(true);
            this.setSelectedGroups(group);
            setTimeout(() => {
                this.setLoading(false);
            }, 500);
        },
        handleSelectStatus(status) {
            this.setLoading(true);
            this.setSelectedStatuses(status);
            setTimeout(() => {
                this.setLoading(false);
            }, 500);
        },
    },

    mounted() {
        this.getAlerts({
            column: this.activeSort,
            direction: this.sortDirection,
        });
    },
};
</script>
